// Keyboard and focus handling for the two slide-outs on the protein-snacks
// PDP. Loaded only by the Compare block and by the inline "Nutrition
// Information" variant of the consumer-information snippet, so the shared
// popup components behave exactly as before everywhere else.
//
// - Compare (<atlas-link-and-popup class="atlas-product-compare">): the
//   shared showPopup() looks for a [role="dialog"] *inside* the popup, but
//   the popup element is itself the dialog, so focus never moves in and its
//   keyup-based Esc handler never sees the key. Here focus is moved into the
//   panel after it opens; Esc calls the element's own hidePopup(), which
//   already returns focus to the trigger.
// - Nutrition Information (CSS checkbox popup, no JS of its own): focus is
//   moved into the panel when the checkbox turns on and back to the trigger
//   when it turns off; Esc turns it off; the label triggers respond to
//   Enter/Space.
(() => {
    if (window.AtlasSnacksPopups) return;
    window.AtlasSnacksPopups = true;

    const COMPARE_HOST = "atlas-link-and-popup.atlas-product-compare";
    const NUTRITION_ROOT = ".product-consumer-information--inline";
    const NUTRITION_TOGGLE = `${NUTRITION_ROOT} .consumer-info-popup-toggle`;

    const focusInto = (panel) => {
        const first = panel.querySelector(".atlas-popup-modal__close") || panel;
        if (typeof window.trapFocus === "function") {
            window.trapFocus(panel, first);
        } else {
            first.focus();
        }
    };

    const releaseFocus = (trigger) => {
        if (typeof window.removeTrapFocus === "function") {
            window.removeTrapFocus(trigger);
        } else {
            trigger?.focus();
        }
    };

    // Compare: runs after the element's own click handler has opened it.
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest?.(
            `${COMPARE_HOST} .atlas-link-trigger`
        );
        if (!trigger) return;

        const host = trigger.closest(COMPARE_HOST);
        const panel = host?.popupBlock;
        if (!panel?.hasAttribute("open")) return;

        trigger.setAttribute("aria-expanded", "true");
        requestAnimationFrame(() => focusInto(panel));
    });

    // Nutrition Information: checkbox state drives open/close.
    document.addEventListener("change", (event) => {
        const toggle = event.target;
        if (!toggle.matches?.(NUTRITION_TOGGLE)) return;

        const root = toggle.closest(NUTRITION_ROOT);
        const panel = root?.querySelector(".atlas-popup-modal");
        const trigger = root?.querySelector("label.atlas-link-trigger");
        if (!panel) return;

        trigger?.setAttribute("aria-expanded", String(toggle.checked));

        if (toggle.checked) {
            requestAnimationFrame(() => focusInto(panel));
        } else {
            releaseFocus(trigger);
        }
    });

    // Enter / Space on the label "buttons" of the checkbox popup.
    document.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;

        const label = event.target.closest?.(`${NUTRITION_ROOT} label[for]`);
        if (!label || event.target !== label) return;

        event.preventDefault();
        label.click();
    });

    // The shared hidePopup() (close button, overlay, Esc) dispatches
    // "modalClosed" on <body>; keep the Compare trigger state in sync.
    document.body.addEventListener("modalClosed", () => {
        document
            .querySelectorAll(`${COMPARE_HOST} .atlas-link-trigger`)
            .forEach((trigger) => {
                const host = trigger.closest(COMPARE_HOST);
                if (!host?.popupBlock?.hasAttribute("open")) return;
                trigger.setAttribute("aria-expanded", "false");
            });
    });

    // Esc closes whichever of these slide-outs is open.
    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;

        document.querySelectorAll(COMPARE_HOST).forEach((host) => {
            if (host.popupBlock?.hasAttribute("open")) {
                host.querySelector(".atlas-link-trigger")?.setAttribute(
                    "aria-expanded",
                    "false"
                );
                host.hidePopup();
            }
        });

        document.querySelectorAll(NUTRITION_TOGGLE).forEach((toggle) => {
            if (!toggle.checked) return;
            toggle.checked = false;
            toggle.dispatchEvent(new Event("change", { bubbles: true }));
        });
    });
})();
